import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=4b5b89b6&"
import script from "./sections.vue?vue&type=script&lang=js&"
export * from "./sections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports